const locale: Locale = {
  ko: {
    above1: '지금까지 총 ',
    above2: ' 개의 청원과 ',
    below: ' 개의 답변이 등록되었습니다',
  },
  en: {
    above1: 'Total ',
    above2: ' petitions are requested, ',
    below: ' are responded',
  },
}

export default locale
